import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (estimate) => async (dispatch) => {

  dispatch(push(getTeamUrl(`estimates/${estimate.id}/view?new=true`)))

}
